// src/Pages/Home/Home.tsx
import React, { useState, useEffect } from 'react';
import './Home.css';
import HeroSectionV2 from '../../components/HeroSectionV2';
import EventCardV2 from '../../components/EventCardV2';
import Billede1 from '../../Images/Billede1.jpg';
import { useLanguage } from '../../context/LanguageContext';
import { Center, Loader } from '@mantine/core';
import { useNavigate } from "react-router-dom";
import { EventDto } from '../Admin/ID/types';

const Home: React.FC = () => {
    const [events, setEvents] = useState<EventDto[]>([]);
    const { language } = useLanguage();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const apiUrl = process.env.REACT_APP_API_URL;
        fetch(`${apiUrl}/api/events`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                setEvents(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching events:', error);
                setLoading(false);
            });
    }, []);

    const filteredEvents = events.filter((event) => event.isInternal === true);

    const handleSignup = (eventId: number) => {
        const isLoggedIn = !!sessionStorage.getItem("authToken");

        if (isLoggedIn) {
            navigate(`/EventPage/${eventId}`);
        } else {
            navigate(`/login?eventId=${eventId}`);
        }
    };

    return (
        <div className="home">
            <HeroSectionV2
                titleEn="Become a volunteer for Badminton Denmark Events"
                titleDa="Bliv frivillig til Badminton Danmarks Events"
                descriptionEn="Welcome to the volunteer portal, where you can sign up as a volunteer for Badminton Denmark events!"
                descriptionDa="Velkommen til frivilligportalen, hvor du kan tilmelde dig som frivillig til Badminton Danmarks arrangementer!"
                imageSrc={Billede1}
            />

            <section className="events-section">
                <p>
                    {language === 'da'
                        ? 'Tilmeld dig til en af disse events.'
                        : 'Signup for the following events'}
                </p>

                {loading && (
                    <Center mt="md">
                        <Loader color="red" />
                    </Center>
                )}

                <div className="events-grid">
                    {filteredEvents.map((event) => (
                        <EventCardV2
                            key={event.eventID}
                            eventId={event.eventID}
                            eventName={event.eventName}
                            eventLogo={event.eventLogoPath}
                            startTime={event.startTime}
                            endTime={event.endTime}
                            onSignup={handleSignup}
                            isActive={event.active}
                        />
                    ))}
                </div>
            </section>
        </div>
    );
};

export default Home;